import { Record } from 'immutable';

export default Record({
    msrp: 0,
    freightPDI: 0,
    taxesAndDuties: 0,
    total: 0,
    shortDisclaimer: '',
});
